// 注册ccui组件
import {
  AdvancedUnitSelector, //高级组织选择器
  AdvancedUserSelector, //高级用户选择器
  SelfUnitUserSelector, //本级用户选择器
  SubLevelUserSelector, //本级及下级单位用户选择器
  SubLevelUnitSelector, //本级及下级单位用户选择器
  // Tooltip, // 文字提示
  TimePicker, // 时间组件
  Tree, // 树形控件
  MaterialCatalog,
  AdvancedSelector,
  Input, // Input输入框
  Aside, // 侧边栏容器
  Table, // 表格
  TableColumn, // 表格列
  Dialog, // 对话框
  Divider, //分割线
  Autocomplete, // 带远程搜索的Input框
  Menu, // 导航菜单
  MenuItem, // 导航菜单项
  Submenu, // 导航菜单二级菜单
  PlainOrgSelector, // 简单组织选择器
  // PlainSearch, // 单条件搜索
  // TopNavMenu, // 顶部导航栏
  Scrollbar, // 滚动容器
  // TimelineApproval, // 审批记录
  Row, // 栅格中的行
  Col, // 栅格中的列
  CardTitle, // 详情标题
  // Progress, // 进度条
  Card, // 卡片
  // Tag, // 标签
  // DataCard, // 数据总览卡
  // Timeline, // 时间线
  // TimelineItem, // 时间线项
  Button, // 按钮
  Link, // 文件链接
  // Alert, // 警告
  Popover, // 弹出框
  CheckboxGroup, // 多选框集合
  Checkbox, // 多选框
  Pagination, // 分页
  // Label, // 审批标签
  // TimeoutLogin, // 超时登录
  Loading, // 加载
  Breadcrumb, // 面包屑
  BreadcrumbItem, // 面包屑项
  // HistoryList, // 历史记录
  Form, // 表单
  FormItem, // 表单项
  // TagSelector, // 下拉多选
  // Select, // select选择器
  Option, // select选择器项
  Message, // 消息提示
  Search, // 高级搜索
  // TopNavMenu2, // 顶部导航栏2
  TopNavMenu3, // 顶部导航3
  // MerchantSelector, // 商家选择器
  DatePicker, // 日期选择器
  // InputTagDatePicker, // 日期标签选择器
  DetailInfo, // 详情文本
  Radio, // 单选框
  // RadioButton, // 单选按钮
  RadioGroup, // 单选框组
  SimpleFooter, // 底部版权条
  // EmpFooter, // 商城首页底部
  TreeSelector, // 树状高级选择器
  AdvancedDatePicker, // 高级日期选择
  StatisticsCard, // 统计卡
  Tabs, // tabs页签
  TabPane, // tab页签选项
  Switch, // 开关
  Image, // 图片
  SwitchComponent, // select选项+input
  DropdownMenu, // 下拉菜单选项容器
  Dropdown, // 下拉菜单外层容器
  DropdownItem, // 下拉菜单项
  BottomGuide, // 底部导航条
  MessageBox, // 弹框
  Cascader, // 级联选择器
  ExportButton, // 导出按钮
  Upload, // 上传
  ButtonGroup, // 按钮分组
  MobileEditor, // 富文本编辑器(移动)
  InputNumber, // 计数器
  SortingSelector, // 分类选择器
  OrgTree, // 组织树
  AreaSelector, // 地区选择器
  Kindeditor, // 富文本编辑器(PC)
  RegionSelector, // 区域选择器
  RegionSelectorG, // 区域选择器国标
  GroupTitle, //分组标题
  SingleSelect,
  DialogTreeTable,
  CheckboxTableChecked,
  EmpFooter
} from "ccui";
import "ccui/lib/theme-chalk/index.css"; // CCUI样式

export default {
  install: (Vue, options) => {
    Vue.use(SelfUnitUserSelector);
    Vue.use(SubLevelUserSelector);
    Vue.use(SubLevelUnitSelector);
    Vue.use(AdvancedUserSelector);
    Vue.use(AdvancedUnitSelector);
    Vue.use(Table);
    Vue.use(TableColumn);
    Vue.use(Pagination);
    Vue.use(MaterialCatalog);
    Vue.use(Tree);
    Vue.use(Input);
    Vue.use(AdvancedSelector);
    Vue.use(Aside);
    // Vue.use(TimeoutLogin);
    Vue.use(PlainOrgSelector);
    Vue.use(CardTitle);
    // Vue.use(TimelineApproval);
    // Vue.use(TopNavMenu);
    Vue.use(MenuItem);
    // Vue.use(HistoryList);
    Vue.use(Menu);
    Vue.use(Scrollbar);
    Vue.use(Submenu);
    // Vue.use(Timeline);
    Vue.use(Autocomplete);
    // Vue.use(TimelineItem);
    Vue.use(Col);
    Vue.use(Row);
    // Vue.use(Label);
    Vue.use(Loading);
    // Vue.use(PlainSearch);
    // Vue.use(Progress);
    Vue.use(Card);
    // Vue.use(Tag);
    // Vue.use(DataCard);
    Vue.use(Breadcrumb);
    Vue.use(BreadcrumbItem);
    // Vue.use(Alert);
    Vue.use(Button);
    Vue.use(Link);
    Vue.use(Popover);
    Vue.use(CheckboxGroup);
    Vue.use(Checkbox);
    Vue.use(Form);
    Vue.use(FormItem);
    // Vue.use(TagSelector);
    // Vue.use(Select);
    Vue.use(Option);
    Vue.use(Search);
    // Vue.use(TopNavMenu2);
    Vue.use(TopNavMenu3);
    // Vue.use(MerchantSelector);
    Vue.use(DatePicker);
    // Vue.use(InputTagDatePicker);
    Vue.use(DetailInfo);
    Vue.use(TimePicker);
    Vue.use(Radio);
    // Vue.use(RadioButton);
    Vue.use(RadioGroup);
    Vue.use(Dialog);
    Vue.use(Divider);
    Vue.use(SimpleFooter);
    Vue.use(TreeSelector);
    Vue.use(StatisticsCard);
    Vue.use(AdvancedDatePicker);
    Vue.use(Tabs);
    Vue.use(TabPane);
    Vue.use(Switch);
    Vue.use(Image);
    Vue.use(SwitchComponent);
    Vue.use(DropdownMenu);
    Vue.use(Dropdown);
    Vue.use(DropdownItem);
    Vue.use(BottomGuide);
    Vue.use(Cascader);
    Vue.use(ExportButton);
    Vue.use(Upload);
    Vue.use(ButtonGroup);
    Vue.use(MobileEditor);
    Vue.use(InputNumber);
    Vue.use(SortingSelector);
    Vue.use(OrgTree);
    Vue.use(AreaSelector);
    Vue.use(Kindeditor);
    // Vue.use(EmpFooter);
    Vue.use(RegionSelector);
    Vue.use(RegionSelectorG);
    Vue.use(GroupTitle);
    Vue.use(SingleSelect);
    Vue.use(DialogTreeTable);
    Vue.use(CheckboxTableChecked);
    Vue.use(EmpFooter);
    Vue.prototype.$message = Message;
    window.$message = Message;
    Vue.prototype.$confirm = MessageBox.confirm;
  }
};
